import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FormattedMessage} from "react-intl";
import {setPlanRestrictionsModals} from "../../../reducers/planRestrictionsModals/actions";
import {Link} from "react-router-dom";
import appRoutes from "../../../appRoutes";

class GroupsAvailable extends PureComponent {


  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
  }

  static getName(){
    return 'GroupsAvailable';
  }

  closeModal() {
    this.props.setPlanRestrictionsModals('');
  }

  render() {
    const {modalOpen} = this.props;

    return <Modal isOpen={modalOpen} toggle={this.closeModal} size="xl">
      <ModalHeader tag={"h2"} toggle={this.closeModal}>Tworzenie grup</ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        Tworzenie grup nie jest dostępne w Twoim planie. Aby mieć do tego dostęp <Link onClick={this.closeModal} to={appRoutes.users.plan}>zmień plan</Link>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.close">{
          (message) =>
            <Button color="warning" className="mb-0" onClick={this.closeModal}>{message}</Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;
  }
}

GroupsAvailable.defaultProps = {
  modalOpen: false,
};

GroupsAvailable.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    modalOpen: state.planRestrictionsModals.name === GroupsAvailable.getName(),
  }
}

export default connect(mapStateToProps, {setPlanRestrictionsModals})(GroupsAvailable);